import { useI18n } from "../i18n/I18nProvider";
import {
  SegmentedControl,
  ThemeDarkIcon,
  ThemeLightIcon,
  ThemeSystemIcon,
  type TabItem,
} from "../ui-kit";
import { useTheme, type Theme } from "./ThemeProvider";

/** Порядок сегментов — от светлого к тёмному, «как в системе» посередине. */
const OPTIONS: { value: Theme; Icon: typeof ThemeLightIcon; labelKey: string }[] = [
  { value: "light", Icon: ThemeLightIcon, labelKey: "theme.light" },
  { value: "system", Icon: ThemeSystemIcon, labelKey: "theme.system" },
  { value: "dark", Icon: ThemeDarkIcon, labelKey: "theme.dark" },
];

export function ThemeToggle() {
  const { t } = useI18n();
  const { theme, setTheme } = useTheme();

  const items: TabItem<Theme>[] = OPTIONS.map(({ value, Icon, labelKey }) => ({
    value,
    title: t(labelKey),
    label: <Icon aria-hidden="true" />,
  }));

  return <SegmentedControl iconOnly items={items} value={theme} onChange={setTheme} />;
}
